<script lang="ts">
  import Button from '$lib/components/Button.svelte';
  import type { UserLessonOrCheckpointStore } from 'shared/src/user/userLessons/user.lessonOrCheckpoint.store';
  import { autorun } from 'mobx';
  import { onDestroy } from 'svelte';
  import { getLessonLink } from './getLessonLink';

  export let lessonStore: UserLessonOrCheckpointStore;

  let props: {
    buttonText: string;
    isAvailable: boolean;
    attemptsRemaining: boolean;
    id: string;
  };
  const destroyer = autorun(() => {
    let buttonText = 'Start';
    if (lessonStore.isInProgress) {
      buttonText = 'Continue';
    } else if (lessonStore.isComplete) {
      buttonText = 'Repeat';
    }
    props = {
      buttonText,
      isAvailable: lessonStore.isAvailable,
      attemptsRemaining:
        lessonStore.type === 'checkpoint' ? lessonStore.hasAttemptsRemaining : true,
      id: lessonStore.id,
    };
  });

  onDestroy(destroyer);
</script>

<a href={getLessonLink(props.id)}>
  <Button
    class="text-base shadow-none w-24"
    disabled={!props.isAvailable || !props.attemptsRemaining}>{props.buttonText}</Button
  >
</a>
